<template>
  <v-app>

       <v-navigation-drawer v-model="drawer" app>

                    <v-img
                        :src="require('@/assets/flli-logo-anim.gif')"
                        height="70px" 
                        contain
                    ></v-img>

           <v-list dense>

               <v-list-item :to="{path: '/'}">
                   <v-list-item-action>
                       <v-icon>home</v-icon>
                   </v-list-item-action>
                   <v-list-item-content>
                       <v-list-item-title>HOME</v-list-item-title>
                   </v-list-item-content>
               </v-list-item>

               <v-list-item :to="{path: '/chooseroute'}">
                   <v-list-item-action>
                       <v-icon>swap_horiz</v-icon>
                   </v-list-item-action>
                   <v-list-item-content>
                       <v-list-item-title>CHOOSE YOUR ROUTE</v-list-item-title>
                   </v-list-item-content>
               </v-list-item>


               <v-list-item :to="{path: '/list/ALL'}">
                   <v-list-item-action>
                       <v-icon>list</v-icon>
                   </v-list-item-action>
                   <v-list-item-content>
                       <v-list-item-title>FIND A COURSE</v-list-item-title>
                   </v-list-item-content>
               </v-list-item>

                <v-list-group 
                    no-action
                >
                    <template v-slot:activator>
                       <v-list-item-action>
                           <v-icon>trending_up</v-icon>
                       </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>GROW YOUR SKILLS</v-list-item-title>
                        </v-list-item-content>
                    </template>

                   <v-list dense color="blue-grey lighten-5"> 
                           <v-list-item :to="{path: '/featuredassm' }">
                               <v-list-item-subtitle>Featured Assessments</v-list-item-subtitle>
                           </v-list-item>
                           <v-list-item :to="{path: '/skillsoft' }">
                               <v-list-item-subtitle>SkillSoft<sup>TM</sup></v-list-item-subtitle>
                           </v-list-item>
                           <v-list-item :to="{path: '/tuition' }">
                               <v-list-item-subtitle>Tuition Assistance</v-list-item-subtitle>
                           </v-list-item>
                           <v-list-item :to="{path: '/tipsheets' }">
                               <v-list-item-subtitle>Tip Sheets</v-list-item-subtitle>
                           </v-list-item>
                           <v-list-item :to="{path: '/connect' }">
                               <v-list-item-subtitle>Connect</v-list-item-subtitle>
                           </v-list-item>
                   </v-list>

                </v-list-group>

               <v-list-item :to="{path: '/calendar'}">
                   <v-list-item-action>
                       <v-icon>calendar_today</v-icon>
                   </v-list-item-action>
                   <v-list-item-content>
                       <v-list-item-title>CHOOSE A DATE</v-list-item-title>
                   </v-list-item-content>
               </v-list-item>

                <v-list-group 
                    no-action
                >
                    <template v-slot:activator>
                       <v-list-item-action>
                           <v-icon>sync</v-icon>
                       </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>LEARNING LIFECYCLE</v-list-item-title>
                        </v-list-item-content>
                    </template>

                   <v-list dense color="blue-grey lighten-5"> 
                           <v-list-item :to="{path: '/expleadership' }">
                               <v-list-item-subtitle>Exploring Leadership</v-list-item-subtitle>
                           </v-list-item>
                           <v-list-item :to="{path: '/list/NMC' }">
                               <v-list-item-subtitle>New Managers</v-list-item-subtitle>
                           </v-list-item>
                           <v-list-item :to="{path: '/list/MMC' }">
                               <v-list-item-subtitle>Middle Managers</v-list-item-subtitle>
                           </v-list-item>
                           <v-list-item :to="{path: '/list/SMEC' }">
                               <v-list-item-subtitle>Senior Manager/Executive</v-list-item-subtitle>
                           </v-list-item>
                           <v-list-item :to="{path: '/tools1' }">
                               <v-list-item-subtitle>Prof Development Skills</v-list-item-subtitle>
                           </v-list-item>
                   </v-list>

                </v-list-group>

                <v-list-item :to="{path: '/slc'}">
                   <v-list-item-action>
                       <v-icon>flag</v-icon>
                   </v-list-item-action>
                   <v-list-item-content>
                       <v-list-item-title>LEADERSHIP CAPABILITIES</v-list-item-title>
                   </v-list-item-content>
                </v-list-item>

                <v-list-item :to="{path: '/electives'}">
                   <v-list-item-action>
                       <v-icon>school</v-icon>
                   </v-list-item-action>
                   <v-list-item-content>
                       <v-list-item-title>ELECTIVES</v-list-item-title>
                   </v-list-item-content>
                </v-list-item>

                <v-list-group 
                    no-action
                >
                    <template v-slot:activator>
                       <v-list-item-action>
                           <v-icon>attach_money</v-icon>
                       </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>FEE FOR SERVICE</v-list-item-title>
                        </v-list-item-content>
                    </template>

                   <v-list dense color="blue-grey lighten-5"> 
                           <v-list-item :to="{path: '/curriculum_FFSC' }">
                               <v-list-item-subtitle>FLLI</v-list-item-subtitle>
                           </v-list-item>
                           <v-list-item :to="{path: '/curriculum_OE' }">
                               <v-list-item-subtitle>Organizational Effectiveness</v-list-item-subtitle>
                           </v-list-item>
                   </v-list>

                </v-list-group>
                
                
                <v-list-group 
                    no-action
                >
                    <template v-slot:activator>
                       <v-list-item-action>
                           <v-icon>info</v-icon>
                       </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>ABOUT FLLI</v-list-item-title>
                        </v-list-item-content>
                    </template>

                   <v-list dense color="blue-grey lighten-5"> 
                           <v-list-item :to="{path: '/about' }">
                               <v-list-item-subtitle>Welcome</v-list-item-subtitle>
                           </v-list-item>
                           <v-list-item :to="{path: '/talent' }">
                               <v-list-item-subtitle>Team</v-list-item-subtitle>
                           </v-list-item>
                           <v-list-item :to="{path: '/facility' }">
                               <v-list-item-subtitle>Facilities</v-list-item-subtitle>
                           </v-list-item>
                           <v-list-item :to="{path: '/facilitators' }">
                               <v-list-item-subtitle>Facilitators</v-list-item-subtitle>
                           </v-list-item>
                   </v-list>

                </v-list-group>

                <v-list-item :to="{path: '/feedback'}">
                   <v-list-item-action>
                       <v-icon>email</v-icon>
                   </v-list-item-action>
                   <v-list-item-content>
                       <v-list-item-title>FEEDBACK</v-list-item-title>
                   </v-list-item-content>
                </v-list-item>

               <!--v-menu right>
                   <template v-slot:activator="{ on }">
                       <v-list-item v-on="on">
                           <v-list-item-action>
                               <v-icon>school</v-icon>
                           </v-list-item-action>
                           <v-list-item-content>
                               <v-list-item-title>CURRICULA</v-list-item-title>
                           </v-list-item-content>
                       </v-list-item>
                   </template>

                   <v-list>

                       <template v-for="item in $options.courseListJson">
                           <v-list-item :to="{path: '/curriculum/' + item.curriculumId }" :key="item.curriculumId">
                               <v-list-item-title class="text-xs-left">{{item.curriculum}}</v-list-item-title>
                           </v-list-item>
                       </template>

                   </v-list>

               </v-menu-->

                <!--v-list-group 
                    no-action
                >
                    <template v-slot:activator>
                       <v-list-item-action>
                           <v-icon>school</v-icon>
                       </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>CURRICULA</v-list-item-title>
                        </v-list-item-content>
                    </template>

                   <v-list dense color="blue-grey lighten-5"> 
                           <v-list-item :to="{path: '/curriculum_NMC' }">
                               <v-list-item-subtitle>New Manager Curriculum</v-list-item-subtitle>
                           </v-list-item>
                           <v-list-item :to="{path: '/curriculum_MMC' }">
                               <v-list-item-subtitle>Middle Manager Curriculum</v-list-item-subtitle>
                           </v-list-item>
                           <v-list-item :to="{path: '/curriculum_SMEC' }">
                               <v-list-item-subtitle>Senior Manager/Executive Curriculum</v-list-item-subtitle>
                           </v-list-item>
                           <v-list-item :to="{path: '/curriculum_EC' }">
                               <v-list-item-subtitle>Elective Curriculum</v-list-item-subtitle>
                           </v-list-item>
                           <v-list-item :to="{path: '/curriculum_FFSC' }">
                               <v-list-item-subtitle>Fee-for-Service Curriculum</v-list-item-subtitle>
                           </v-list-item>
                   </v-list>

                </v-list-group-->

               <!--v-menu right>
                   <template v-slot:activator="{ on }">
                       <v-list-item v-on="on">
                           <v-list-item-action>
                               <v-icon>school</v-icon>
                           </v-list-item-action>
                           <v-list-item-content>
                               <v-list-item-title>CURRICULA</v-list-item-title>
                           </v-list-item-content>
                       </v-list-item>
                   </template>
                   <v-list>
                           <v-list-item :to="{path: '/curriculum1' }">
                               <v-list-item-title class="text-xs-left">NEW MANAGER CURRICULUM</v-list-item-title>
                           </v-list-item>
                           <v-list-item :to="{path: '/curriculum2' }">
                               <v-list-item-title class="text-xs-left">MIDDLE MANAGER CURRICULUM</v-list-item-title>
                           </v-list-item>
                           <v-list-item :to="{path: '/curriculum3' }">
                               <v-list-item-title class="text-xs-left">SENIOR MANAGER/EXECUTIVE CURRICULUM</v-list-item-title>
                           </v-list-item>
                           <v-list-item :to="{path: '/curriculum4' }">
                               <v-list-item-title class="text-xs-left">FLLI ELECTIVE CURRICULUM</v-list-item-title>
                           </v-list-item>
                           <v-list-item :to="{path: '/curriculum5' }">
                               <v-list-item-title class="text-xs-left">FLLI FEE-FOR-SERVICE CURRICULUM</v-list-item-title>
                           </v-list-item>
                           <v-list-item :to="{path: '/curriculum6' }">
                               <v-list-item-title class="text-xs-left">ORGANIZATIONAL EFFECTIVENESS FEE-FOR-SERVICE CURRICULUM</v-list-item-title>
                           </v-list-item>
                   </v-list>
               </v-menu-->


                <!--v-list-group
                    no-action
                >
                    <template v-slot:activator>
                       <v-list-item-action>
                           <v-icon>build</v-icon>
                       </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>TOOLS/SERVICES</v-list-item-title>
                        </v-list-item-content>
                    </template>

                   <v-list dense color="blue-grey lighten-5">
                           <v-list-item :to="{path: '/tools1'}">
                               <v-list-item-subtitle>Featured Assessments</v-list-item-subtitle>
                           </v-list-item>
                           <v-list-item :to="{path: '/tools2'}">
                               <v-list-item-subtitle>Skillsoft<sup>TM</sup> Training Library</v-list-item-subtitle>
                           </v-list-item>
                           <v-list-item :to="{path: '/tools3'}">
                               <v-list-item-subtitle>Yammer</v-list-item-subtitle>
                           </v-list-item>
                           <v-list-item :to="{path: '/tools4'}">
                               <v-list-item-subtitle>STEM AVSED Program</v-list-item-subtitle>
                           </v-list-item>
                           <v-list-item :to="{path: '/tools5'}">
                               <v-list-item-subtitle>Rotational Assignment Programs</v-list-item-subtitle>
                           </v-list-item>
                           <v-list-item :to="{path: '/tools6'}">
                               <v-list-item-subtitle>Tuition Assistance and Reimbursement</v-list-item-subtitle>
                           </v-list-item>
                   </v-list>

                </v-list-group>

               <v-list-item :to="{path: '/facilitators'}">
                   <v-list-item-action>
                       <v-icon>people</v-icon>
                   </v-list-item-action>
                   <v-list-item-content>
                       <v-list-item-title>FACILITATORS</v-list-item-title>
                   </v-list-item-content>
               </v-list-item-->

               <template v-if="isAuthenticated == false">

                   <v-divider></v-divider>

                   <v-list-item :to="{path: '/signup'}">
                       <v-list-item-action>
                           <v-icon>account_circle</v-icon>
                       </v-list-item-action>
                       <v-list-item-content>
                           <v-list-item-title>SIGN UP</v-list-item-title>
                       </v-list-item-content>
                   </v-list-item>

               </template>


               <!--template v-if="isAdmin == true">

                <v-divider></v-divider>

                   <v-list-group prepend-icon="settings"
                                 value="true">
                       <template v-slot:activator>
                           <v-list-item>
                               <v-list-item-title>Administration</v-list-item-title>
                           </v-list-item>
                       </template>

                   <v-list dense color="blue-grey lighten-5">

                       <v-list-item :to="{path: '/admin/coursedates'}">
                           <v-list-item-title>Manage Course Dates</v-list-item-title>
                           <v-list-item-action>
                               <v-icon>calendar_today</v-icon>
                           </v-list-item-action>
                       </v-list-item>

                       <v-list-item :to="{path: '/admin/rqapprove'}">
                           <v-list-item-title>Approve Training Requests</v-list-item-title>
                           <v-list-item-action>
                               <v-icon>check_circle_outline</v-icon>
                           </v-list-item-action>
                       </v-list-item>
                   </v-list>

                   </v-list-group>

               </template-->

               <template v-if="isAdmin == true">

                <v-divider></v-divider>

                <v-list subheader>
                    <v-subheader>Administration</v-subheader>

                       <v-list-item :to="{path: '/admin/coursedates'}">
                           <v-list-item-title>Manage Course Dates</v-list-item-title>
                           <v-list-item-action>
                               <v-icon>calendar_today</v-icon>
                           </v-list-item-action>
                       </v-list-item>

                       <v-list-item :to="{path: '/admin/rqapprove'}">
                           <v-list-item-title>Approve Training Requests</v-list-item-title>
                           <v-list-item-action>
                               <v-icon>check_circle_outline</v-icon>
                           </v-list-item-action>
                       </v-list-item>
                   </v-list>

               </template>

           </v-list>
        </v-navigation-drawer>


    <v-app-bar color="#003A70" dark app>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

      <v-toolbar-title class="hidden-sm-and-down">
        <span class="font-weight-light">MY </span>
        <span>FLLI</span>
      </v-toolbar-title>

      <v-toolbar-title class="hidden-md-and-up">
        <span class="font-weight-light">MY </span>
        <span>FLLI</span>
      </v-toolbar-title>


      <v-spacer></v-spacer>

        <v-menu bottom v-if="isAuthenticated">
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on">
                <v-icon>more_vert</v-icon>
              </v-btn>
            </template>

            <v-list>

              <v-list-item to="/profile">
                    <v-list-item-action>
                        <v-icon>account_circle</v-icon>
                    </v-list-item-action>
                    <v-list-item-title>{{signedInUserName}}</v-list-item-title>
              </v-list-item>

                <v-list-item :to="{path: '/mycourses'}">
                    <v-list-item-action>
                        <v-icon>work</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>My Courses</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-divider></v-divider>

              <v-list-item @click="userSignOut">
                <v-list-item-title class="text-xs-center">Sign Out</v-list-item-title>
              </v-list-item>

            </v-list>

          </v-menu>
          <v-btn to="/signin" v-else>Sign In</v-btn>

    </v-app-bar>

    <v-content>
      <!--CourseList/-->
                <router-view :key="$route.fullPath"></router-view>
    </v-content>

        <v-footer color="#00A0DF"
            class="flex-grow-1 font-weight-medium white--text" app
        >
            &copy; {{ new Date().getFullYear() }} &nbsp;AVYANCE LLC
            <v-spacer></v-spacer>
            <v-btn icon small class="white--text" to="/help"><v-icon>help</v-icon></v-btn>
        </v-footer>

  </v-app>
</template>

<script>import Vue from 'vue'
import VueHead from 'vue-head'

import COURSE_LIST_JSON from './json/course_list_data.json'

Vue.use(VueHead)

export default {
  name: 'App',
  data () {
    return {
    drawer: false
    }
  },
  head: {
    //title: {
    //  inner: 'FLLI Catalog'
    //},
    // Meta tags
        meta: [
            { name: 'application-name', content: 'FLLI Catalog' },
            { name: 'description', content: 'FLLI Course Catalog 2019', id: 'desc' }, // id to replace intead of create element
            { name: 'apple-mobile-web-app-capable', content: 'yes' },
            { name: 'apple-mobile-web-app-status-bar-style', content: 'default' },
            { name: 'apple-mobile-web-app-title', content: 'FLLI Catalog' }
        ],
        // link tags
        link: [
            { rel: 'manifest', crossorigin: 'use-credentials' , href: '/manifest.json' },
            { rel: 'apple-touch-startup-image', href: '/img/splash/splash_640x1136_.png', media: '(device-width: 320px) and (device-height: 568px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)' },
            { rel: 'apple-touch-startup-image', href: '/img/splash/splash_750x1294_.png', media: '(device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)' },
            { rel: 'apple-touch-startup-image', href: '/img/splash/splash_1242x2148_.png', media: '(device-width: 414px) and (device-height: 736px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)' },
            { rel: 'apple-touch-startup-image', href: '/img/splash/splash_1125x2436_.png', media: '(device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)' },
            { rel: 'apple-touch-startup-image', href: '/img/splash/splash_1536x2048_.png', media: '(min-device-width: 768px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait)' },
            { rel: 'apple-touch-startup-image', href: '/img/splash/splash_1668x2224_.png', media: '(min-device-width: 834px) and (max-device-width: 834px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait)' },
            { rel: 'apple-touch-startup-image', href: '/img/splash/splash_2048x2732_.png', media: '(min-device-width: 1024px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait)' },
            { rel: 'apple-touch-icon', href: '/img/icons/apple-touch-icon.png', id: 'apple-touch-icon' }
        ]
  },
  computed: {
    appTitle () {
        return this.$store.state.appTitle
    },
    isAdmin () {
      return this.$store.getters.isAdmin
    },
    isAuthenticated () {
      return this.$store.getters.isAuthenticated
    },
    signedInUserName () {
      return this.$store.getters.signedInUserName
    }
  },
  methods: {
    userSignOut () {
      this.$store.dispatch('userSignOut')
    },
  },
  courseListJson: COURSE_LIST_JSON
}
</script>

<style>
.menuImage {
  margin: 10px;
}
.logoPlace {
  align-items: center;
  height: 60px;
}
.v-application--is-ltr .v-list-item__action:first-child  {
    margin-right: 12px;
}
.v-list-group .v-list-group__header .v-list-item__icon.v-list-group__header__append-icon {
    -ms-flex-item-align: center;
    align-self: center;
    margin: 0;
    min-width: 24px;
    -webkit-box-pack: end;
    -ms-flex-pack: end;
    justify-content: flex-end;
}
</style>